function showDocModalForm(){
    if(typeof event === "object") {
        event.preventDefault();
    }
    else{
        console.log("Event object not found.")
    }
    let bodyTag = document.getElementsByTagName("body")[0];
    let modalFormStruct = `
    <div class="feedback-modal modal modal--show">
        <div class="modal__inner">
          <div class="modal__close" data-close=""></div>
          <div class="modal__block modal__block--form">
            <form role="form" method="POST" id="question-form" action="mail.php">
              <div class="q-form">
                <div class="q-form__header">
                  <h2 class="q-form__title">Вопросы, идеи, предложения</h2>
                  <p class="q-form__caption">Что бы вас ни волновало касательно наших продуктов и нашей работы, пишите</p>
                </div>
                <div class="q-form__fields">
                  <div class="q-form__row q-form__row--name">
                    <input class="q-form__input js_name-input js_input" type="text" name="name" data-field="" value="" placeholder="Имя и фамилия *" required=""><span class="q-form__error q-form__error--name"></span>
                  </div>
                  <div class="q-form__row q-form__row--surname">
                    <input class="q-form__input js_surname-input js_input" type="text" name="surname" data-field="" value="" placeholder="Ваша фамилия *"><span class="q-form__error q-form__error--surname"></span>
                  </div>
                  <div class="q-form__row q-form__row--company">
                    <input class="q-form__input" type="text" name="Company" data-field="" value="" placeholder="Компания">
                  </div>
                  <div class="q-form__row q-form__row--email">
                    <input class="q-form__input js_email-input js_input" type="email" name="email" data-field="" value="" placeholder="E-mail *" required=""><span class="q-form__error q-form__error--email"></span>
                  </div>
                  <div class="q-form__row q-form__row--text">
                    <textarea class="q-form__textarea js_msg-input js_input" rows="5" name="message" data-field="" placeholder="Сообщение *" required=""></textarea><span class="q-form__error q-form__error--text"></span>
                  </div><i class="q-form__tip">* обязательные поля</i>
                </div>
                <div class="q-form__bottom"><a class="q-form__mailto" href="mailto:">Использовать почтовый клиент</a>
                  <input class="q-form__submit-btn" type="submit" name="submit" value="Отправить" disabled="disabled">
                </div>
              </div>
            </form>
          </div>
          <div class="modal__block modal__block--done" id="done-message" hidden="">
            <div class="success">
              <h2 class="success__title">Спасибо!</h2>
              <p class="success__caption">Ваше сообщение отправлено в службу технической поддержки.</p>
            </div>
          </div>
        </div>
      </div>
    `;
    bodyTag.insertAdjacentHTML('beforeend', modalFormStruct);

    //привязка валидаторов к событиям сгенерированных элементов
    validateForm();
}

//пробрасываем функцию в глобальную область видимости
window.showDocModalForm = showDocModalForm;

function destroyDocModalForm(){
    let modal = document.querySelector(".modal.modal--show");
    modal.parentNode.removeChild(modal);
}

//функции валидаторы
function validateEmail() {
    let input = this;
    let inputContainer = this.parentElement;
    if (input.value) {
        let pattern = /^([a-z0-9_\.-])+@[a-z0-9-]+\.([a-z]{2,12}\.)?[a-z]{2,12}$/i;
        if (pattern.test(input.value)) {
            input.classList.remove('invalid');
            input.classList.add('valid');
            inputContainer.classList.remove('invalid');
            return;
        } else {
            input.classList.add('invalid');
            input.classList.remove('valid');
            inputContainer.classList.add('invalid');
            input.nextElementSibling.innerText = 'Некорректный e-mail:';
        }
    } else {
        input.classList.add('invalid');
        input.classList.remove('valid');
        inputContainer.classList.add('invalid');
        input.nextElementSibling.innerText = 'Не введён:';
    }
}

function validateName() {
    let input = this;
    let inputContainer = this.parentElement;
    if (input.value) {
        let pattern = /^[а-яёА-ЯЁa-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u;
        if (pattern.test(input.value)) {
            input.classList.remove('invalid');
            input.classList.add('valid');
            inputContainer.classList.remove('invalid');
            return;
        } else {
            input.classList.add('invalid');
            input.classList.remove('valid');
            inputContainer.classList.add('invalid');
            input.nextElementSibling.innerText = 'Некорректное имя:';
        }
    } else {
        input.classList.add('invalid');
        input.classList.remove('valid');
        inputContainer.classList.add('invalid');
        input.nextElementSibling.innerText = 'Не введены:';
    }
}

function validateTextarea() {
    let input = this;
    let inputContainer = this.parentElement;
    if (input.value) {
        input.classList.remove('invalid');
        input.classList.add('valid');
        inputContainer.classList.remove('invalid');
        return;
    } else {
        input.classList.add('invalid');
        input.classList.remove('valid');
        inputContainer.classList.add('invalid');
        input.nextElementSibling.innerText = 'Не введено:';
    }
}

// Привязка валидаторов к элементам (с очисткой привязки)
function validateForm() {
    let inputEmail = document.querySelector('.js_email-input');
    let inputName = document.querySelector('.js_name-input');
    let inputMessage = document.querySelector('.js_msg-input');
    let input = document.querySelectorAll('.js_input');
    let form = document.querySelector('#question-form');
    let close = document.querySelector('.modal__close');
    form.removeEventListener('submit',sendDataEvent);
    form.addEventListener('submit',sendDataEvent);
    close.removeEventListener('click',destroyDocModalForm);
    close.addEventListener('click',destroyDocModalForm);
    inputEmail.removeEventListener('input', validateEmail);
    inputEmail.removeEventListener('blur', validateEmail);
    inputEmail.addEventListener('input', validateEmail);
    inputEmail.addEventListener('blur', validateEmail);
    inputName.removeEventListener('input', validateName);
    inputName.removeEventListener('blur', validateName);
    inputName.addEventListener('input', validateName);
    inputName.addEventListener('blur', validateName);
    inputMessage.removeEventListener('keyup', validateTextarea);
    inputMessage.removeEventListener('blur', validateTextarea);
    inputMessage.addEventListener('keyup', validateTextarea);
    inputMessage.addEventListener('blur', validateTextarea);
    input.forEach(function (inputItem) {
        inputItem.removeEventListener('keyup', enableSubmitBtn);
        inputItem.addEventListener('keyup', enableSubmitBtn);
    });
}
function enableSubmitBtn() {

    let submit = document.querySelector('.q-form__submit-btn');
    let validInputs = document.querySelectorAll('.js_input.valid');

    if (validInputs.length === 3) {
        submit.removeAttribute('disabled');
    } else {
        submit.setAttribute('disabled', 'disabled');
    }
}

function sendData() {
    let xhr = new XMLHttpRequest();
    let formFields = document.querySelectorAll('[data-field]');
    let body = '';

    formFields.forEach((field) => {
        body += (field.name + '=' + encodeURIComponent(field.value) + '&');
    });

    xhr.open('POST', '/ru/dist/mail.php');
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.setRequestHeader('x-requested-with', 'XMLHttpRequest');

    xhr.send(body.slice(0, -1));

    xhr.onreadystatechange = function() {
        if (xhr.readyState > 3 && xhr.status==200) {
            let modalSuccess = document.querySelector('.modal__block--done');
            let modalForm = document.querySelector('.modal__block--form');
            closeBlock(modalForm);
            modalSuccess.removeAttribute('hidden');
        }
    };
}

function closeBlock(element) {
    element.setAttribute('hidden', true);
}

function sendDataEvent(e){
    e.preventDefault();
    let hiddenField = document.querySelector('.js_surname-input');
    if(hiddenField.value.length > 0){
        console.error("Callback form hidden field is not empty");
        return;
    }
    sendData();
}